import React, {useRef, useEffect} from "react";
import {Row} from "antd";

const TrailFeedback = props => {
    const {title, buttons, children} = props;
    const feedbackRef = useRef(null);

    useEffect(() => {
        if (feedbackRef.current) {
            feedbackRef.current.focus({preventScroll: true});
        }
    }, [title, buttons]);

    return (
        <div
            ref={feedbackRef}
            tabIndex={-1}
            className="ch-question-feedback"
            role="region"
            aria-labelledby="feedback-header"
            aria-live="assertive"
        >
            {title && (
                <Row
                    id="feedback-header"
                    justify="center"
                    className="ch-question-feedback-title margin-b--m"
                >
                    {title}
                </Row>
            )}
            <div className="ch-feedback-content">
                {children}
            </div>
            {buttons && (
                <Row justify="center" className="margin-t--m mediumGap">
                    {buttons}
                </Row>
            )}
        </div>
    )
}

export default TrailFeedback;